import React from "react";
import {
  Typography,
  Button,
  Box,
  Container,
  Divider,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import FORM from '../assets/Hostel_Admition_form.pdf'

const points = [
  "१. सदरचे वसतिगृह हे उच्च शिक्षण विभागाअंतर्गत असून या वसतिगृहाचे नियंत्रण अधिकारी मा. सहसंचालक, उच्च शिक्षण, जळगांव विभाग, जळगांव हे आहेत.",
  "२ .वसतिगृह प्रवेश क्षमता :- सदर वसतिगृह हे आर्थिकदृष्टया मागासवर्गीय मूलांचे वसतिगृह आहे. वसतिगृहाची शासनमान्य प्रवेश क्षमता १०० विद्यार्थ्यांची आहे. मात्र इमारत ही भाडेतत्वावर असल्याने सदर इमारतीमध्ये ५० विद्यार्थी राहू शकतात व त्यांना आवश्यक मूलभूत सोयीसुविधा उपलब्ध होऊ शकतात करीता ५० विद्यार्थ्यांना प्रवेश देण्यात येतो.",
  "३. प्रवेश कोणास घेता येईल :- इयत्ता ८ वी ते पदव्यूत्तर पदवी पर्यंत शिक्षण घेणाऱ्या आर्थिकदृष्टया मागासवर्गीय विद्यार्थ्यास प्रवेश घेता येईल.",
  "४. विद्यार्थ्यांना प्रवेश घेण्यासाठीचे निकष :- विद्यार्थ्यांच्या पालकाचे वार्षिक उत्पन्न रुपये १ लाख पेक्षा जास्त नसावे. त्यासाठी मा. तहसिलदार यांच्याकडील पालकांचा उत्पन्न दाखला आवश्यक आहे. तसेच मागासवर्गीय विद्यार्थ्यांना जात प्रमाणपत्र व जात वैधता प्रमाणपत्र असणे आवश्यक आहे. तसेच विद्यार्थी महाराष्ट्रातील रहिवासी (डोमिसाईल) असावा व तसे मा. तहसिलदार यांचे प्रमाणपत्र आवश्यक आहे. तसेच त्याला किमान ६०% मार्क दरवर्षी मिळणे आवश्यक आहे.",
  "५. वसतिगृहात मुलांना मिळणाऱ्या सोयी सुविधा :- वसतिगृहात प्रवेशित विद्यार्थ्यांना त्यांच्या राहण्याची व दोन वेळेस जेवणाची मोफत सुविधा उपलब्ध आहे. वसतिगृहात प्रवेशित विद्यार्थ्यांची दैनंदिन हजेरी ही बायोमॅट्रीक मशिनद्वारे घेण्यात येते.",
  "६. वसतिगृहाच्या सुरक्षेबाबत :- वसतिगृहाच्या/विद्यार्थ्यांच्या सुरक्षेसाठी ०३ सुरक्षा रक्षक कंत्राटी तत्वावर कार्यरत आहेत. व ०१ सफाईगार  कंत्राटी तत्त्वावर कार्यरत आहे. तसेच वसतिगृहाच्या सुरक्षेसाठी संपूर्ण परिसरात एकूण १८ सी.सी.टी.व्ही. बसविण्यात आलेले आहेत."
];


const positions = [
  { id: 1, number: '१', title: "गृहप्रमुख", approved: "१", filled: "१", vacant: "०" },
  { id: 2, number: '२', title: "वरिष्ठ लिपीक", approved: "१", filled: "१", vacant: "०" },
  { id: 3, number: '३', title: "कनिष्ठ लिपीक", approved: "१", filled: "०", vacant: "१" },
  { id: 4, number: '४', title: "मुख्य स्वयंपाकी", approved: "१", filled: "१", vacant: "०" },
  { id: 5, number: '५', title: "स्वयंपाक मदतनिस", approved: "१", filled: "१", vacant: "०" },
  { id: 6, number: '६', title: "शिपाई", approved: "१", filled: "०", vacant: "१" },
  { title: "एकूण", approved: "६", filled: "४", vacant: "२" },
];


const staff = [
  { id: 1, number: '१', name: "श्री.प्रकाश वसंत सोनवणे", post: "गृहप्रमुख" },
  { id: 2, number: '२', name: "श्री.अतूल श्रीकांत सहजे", post: "वरिष्ठ लिपीक" },
  { id: 4, number: '३', name: "श्रीमती संध्या प्रल्हाद पाटील", post: "मुख्य स्वयंपाकी" },
  { id: 5, number: '४', name: "श्रीमती लता विजय जाधव", post: "स्वयंपाक मदतनिस" },
];

const VastigruhMahiti = () => {
  return (
    <>
      <Container maxWidth="md" sx={{ py: 6 }}>
        <Typography variant="h6" sx={{ textAlign: "center", color: "#002fa7", fontSize: 25 }}>
          वसतिगृहा बाबतची माहिती
        </Typography>

        {points.map((point, index) => (
          <Box key={index}>
            <Typography
              variant="h6"
              sx={{
                fontSize: { xs: "1rem", sm: "1.1rem" },
                lineHeight: 1.8,
              }}
            >
              {point}
            </Typography>
            {index !== points.length - 1 && (
              <Divider sx={{ my: 0.6, color: "#101010" }} />
            )}
          </Box>
        ))}
      </Container>

      <Box
        sx={{
          p: 4,
          textAlign: "center",
          backgroundColor: "#e3f2fd",
          borderRadius: 4,
          boxShadow: 3,
          maxWidth: 600,
          mx: { xs: 2, sm: "auto" },
          mt: { xs: 2, sm: 3 },
          mb: { xs: 4, sm: 6 },
        }}

      >
        <Typography
          variant="h5"
          sx={{ fontWeight: "bold", mb: 2, color: "#002fa7" }}
        >
          प्रवेशासाठी फॉर्म डाउनलोड करा
        </Typography>

        <Typography variant="body1" sx={{ mb: 3, color: "#333" }}>
          प्रवेश प्रक्रिया सुरू आहे. कृपया खालील बटणावर क्लिक करून फॉर्म डाउनलोड करा आणि आवश्यक माहिती भरून सादर करा.
        </Typography>

        <Button
          variant="contained"
          color="primary"
          size="large"
          startIcon={<DownloadIcon />}
          href={FORM}
          target="_blank"
        >
          फॉर्म डाउनलोड करा
        </Button>
      </Box>
      <Box sx={{ px: { xs: 1, sm: 20 }, mb: 5 }}>
        <Typography variant="h6" sx={{ textAlign: "center", m: 3, color: "#002fa7", fontSize: 25 }}>
          वस्तिगृहासाठी मंजूर, भरलेली व रिक्त पदे
        </Typography>
        <TableContainer
          sx={{
            border: "1px solid #c8c8c8",
            borderRadius: 3,

          }}
        >
          <Table size="medium" sx={{ minWidth: 600, }}>
            <TableHead sx={{ bgcolor: "#002fa7" }}>
              <TableRow>
                <TableCell
                  sx={{ textAlign: "center", fontSize: 16, color: "#fff" }}
                >
                  अ.क्र.
                </TableCell>
                <TableCell
                  sx={{ textAlign: "center", fontSize: 16, color: "#fff" }}

                >
                  पदनाम
                </TableCell>
                <TableCell
                  sx={{ textAlign: "center", fontSize: 16, color: "#fff" }}

                >
                  मंजूर पदे
                </TableCell>
                <TableCell
                  sx={{ textAlign: "center", fontSize: 16, color: "#fff" }}

                >
                  भरलेली पदे
                </TableCell>
                <TableCell
                  sx={{ textAlign: "center", fontSize: 16, color: "#fff" }}

                >
                  रिक्त पदे
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {positions.map((row) => {
                const isTotalRow = row.title === "एकूण";
                return (
                  <TableRow key={row.id || row.title}>
                    <TableCell sx={{ textAlign: "center", fontSize: 15, fontWeight: isTotalRow ? "bold" : "normal" }}>
                      {row.number}
                    </TableCell>
                    <TableCell sx={{ textAlign: "center", fontSize: 15, fontWeight: isTotalRow ? "bold" : "normal" }}>
                      {row.title}
                    </TableCell>
                    <TableCell sx={{ textAlign: "center", fontSize: 15, fontWeight: isTotalRow ? "bold" : "normal" }}>
                      {row.approved}
                    </TableCell>
                    <TableCell sx={{ textAlign: "center", fontSize: 15, fontWeight: isTotalRow ? "bold" : "normal" }}>
                      {row.filled}
                    </TableCell>
                    <TableCell sx={{ textAlign: "center", fontSize: 15, fontWeight: isTotalRow ? "bold" : "normal" }}>
                      {row.vacant}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Box >

      <Box sx={{ px: { xs: 1, sm: 35 }, mb: 5 }}>
        <Typography variant="h6" sx={{ textAlign: "center", m: 3, color: "#002fa7", fontSize: 25 }}>
          कार्यरत कर्मचाऱ्यांची नावे व पदनाम
        </Typography>
        <TableContainer
          sx={{
            border: "1px solid #c8c8c8",
            borderRadius: 3,

          }}
        >
          <Table size="medium" sx={{ minWidth: 600, textAlign: 'center' }}>
            <TableHead sx={{ bgcolor: "#002fa7" }}>
              <TableRow>
                <TableCell
                  sx={{ textAlign: "center", fontSize: 16, color: "#fff" }}
                >
                  अ.क्र.
                </TableCell>
                <TableCell
                  sx={{ textAlign: "center", fontSize: 16, color: "#fff" }}

                >
                  कार्यरत कर्मचाऱ्याचं नावे
                </TableCell>
                <TableCell
                  sx={{ textAlign: "center", fontSize: 16, color: "#fff" }}

                >
                  धारण केलेले पद
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {staff.map((row) => (
                <TableRow key={row.id}>
                  <TableCell sx={{ textAlign: "center", fontSize: 15, }}>{row.number}</TableCell>
                  <TableCell sx={{ textAlign: "center", fontSize: 15, }}>{row.name}</TableCell>
                  <TableCell sx={{ textAlign: "center", fontSize: 15, }}>{row.post}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box >
    </>
  );
};

export default VastigruhMahiti;

